import React from "react";
import PropTypes from "kf-proptypes/widgets";

import styles from "./emptystate.css";

export function EmptyStateMuted(props) {
  const { img, text } = props;
  return (
    <div
      className={`${styles.emptystate} ${styles.muted}`}
      data-component="emptystate"
    >
      {img}
      {text && <span className={`small400 ${styles.mutedText}`}>{text}</span>}
    </div>
  );
}

EmptyStateMuted.propTypes = {
  img: PropTypes.node.isRequired,
  text: PropTypes.string
};
